/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormContainer from '../../../FormContainer/FormContainer';
import { handleFormObjectChange } from '../../../Utilities/HandleFormObjectChange';
import { NetworkRequest } from '../../../Utilities/NetworkRequests/NetworkRequests';
import { editPlacementState } from './state';
import { validateForSubmit } from '../../../Utilities/ValidationHelper/ValidateForm';
import { buildFormFields } from '../../../Utilities/formHelper';
import { formatSubmitValues } from '../../../Utilities/SubmitHelper/FormatForSubmit';
import { formatAffiliateValue } from '../../../Utilities/getAffiliateIDFromName';
import { handleChange } from '../../../Filters/actions/actions';

class EditPlacement extends Component {
  state = {
    formValues: editPlacementState(),
    submitting: false,
    dialog: {
      message: '',
      type: 'error',
      title: 'Error'
    }
  };

  componentDidMount() {
    if (this.props.row) {
      this.loadFormValues();
    }
  }

  loadFormValues = () => {
    const { formValues } = this.state;
    const { row } = this.props;

    Object.keys(formValues).map((column) =>
      Object.assign(formValues, formValues, {
        [column]: {
          ...formValues[column],
          value: row[column] || formValues[column].value
        }
      })
    );
    this.setState({ formValues });
  };

  handleChange = (field, value) => {
    const formValues = handleFormObjectChange(field, value, {
      ...this.state.formValues
    });
    this.setState({ formValues });
  };

  toggleDialog = (message = '', type = 'error', title = 'Error') =>
    this.setState({
      dialog: { ...this.state.dialog, message, type, title }
    });

  handleSubmit = () => {
    const { valid, messages } = validateForSubmit(this.state.formValues);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return false;
    }
    this.handleSubmitRequest();
  };

  handleSubmitRequest = () => {
    const { row } = this.props;
    const submitValues = formatSubmitValues(this.state.formValues);
    this.setState({ submitting: true }, () =>
      NetworkRequest('affiliates', {
        action: 'saveEverQuoteSources',
        affiliate_id: formatAffiliateValue(submitValues.affiliateID),
        channel: submitValues.everquoteSrc,
        vertical_id: submitValues.site,
        id: row ? row.id : null,
        status: '1'
      })
        .then(({ data }) => this.handleResponse(data, submitValues))
        .catch(() => this.setState({ submitting: false }))
    );
  };

  handleResponse = (data, submitValues) => {
    const { row, onChange, handleChange } = this.props;
    this.setState({ submitting: false });
    if (data && data.success === true) {
      this.toggleDialog(
        data.message || 'Source was saved successfully.',
        'success',
        'Success'
      );
      if (row) {
        onChange(row, submitValues);
      }
      handleChange('reloadReport', true);
    } else {
      this.toggleDialog(
        data.message || 'Something went wrong.',
        'error',
        'Error'
      );
    }
  };

  render() {
    const { formValues, submitting, dialog } = this.state;
    return (
      <FormContainer
        formValues={buildFormFields(formValues, this.state)}
        submitting={submitting}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        inputWidth={8}
        separateBlock
        dialog={dialog}
        toggleDialog={this.toggleDialog}
        toggleActionDrawer={this.props.toggleDrawer}
      />
    );
  }
}

export default connect(
  () => ({}),
  (dispatch) =>
    bindActionCreators(
      {
        handleChange
      },
      dispatch
    )
)(EditPlacement);
